
import { Component, Prop, Vue } from 'vue-property-decorator'
import { HierarchyTrail, SearchFilters } from '../../schemas'

@Component
export default class SearchLowResult extends Vue {
  @Prop()
    searchFilters: SearchFilters

  @Prop()
    hierarchyTrail: HierarchyTrail[]

  scrollTop() {
    this.$puScrollTo('[data-back-to-top]', {
      duration: 200,
    })
  }

  get isCitySearch() {
    return this.hierarchyTrail && this.hierarchyTrail?.length === 4
  }

  get cityName() {
    return this.isCitySearch ? this.hierarchyTrail[3].name : ''
  }

  get isHierarchySearch(): boolean {
    const hierarchyPath = this.searchFilters.hierarchyPath || ''
    return hierarchyPath.split('/').length > 1
  }

  get lowResultsHierarchyTrail(): HierarchyTrail[] {
    const hierarchyTrail = this.hierarchyTrail
    return hierarchyTrail
      ? hierarchyTrail.slice(0, hierarchyTrail.length - 1)
      : []
  }

  get isCategoriesSearch(): boolean {
    const categoryIds = this.searchFilters.categoryIds || []
    return !!categoryIds.length
  }

  get isDatesSearch(): boolean {
    return !!this.searchFilters.dates
  }

  get hasFacetsFilters(): boolean {
    const facets = this.searchFilters.facets || []
    return !!facets?.length
  }

  get isPriceRangeSearch(): boolean {
    const priceRange = this.searchFilters.priceRange || undefined
    return !!(priceRange?.max && priceRange.max !== Infinity)
  }

  get isPointSearch(): boolean {
    return !!this.searchFilters.area && !this.searchFilters.area.isEmptyPoint
  }

  get isBoundsSearch(): boolean {
    return !!this.searchFilters.bounds
  }
}
